<template>
    <div id="page" style="background-color: rgba(248, 248, 248, 1);">
        <div class="banner-bg">
            <img src="~@/assets/images/menu/行业培训.png" style="width: 100%;"/>
        </div>
        <section class="section"  style="background-color: rgba(241, 241, 241, 1);height: 70px;padding: 0;">
            <div class="container">
                <div class="row" style="height: 70px;display:flex;align-items: center;">
                    <template v-for="item in key">
                        <div :key="item" class="col-lg-2 col-md-2 active-nav-1" :class="active==item?'active-nav':''" @click="activeChange(item)">{{item}}</div>
                    </template>
                </div>
            </div>
        </section>
        <section class="section" style="padding: 0;padding-bottom:0;" >
            <div class="container">
                <div class="row" style="padding:20px 0;" v-show="active==key[0]">
                    <template  v-for="(item,index) in 12">
                        <div class="col-lg-3 col-md-6"  :key="index">
                            <div class="list-content">
                                <img src="~@/assets/images/menu/行业培训默认封面图.png" width="285" height="160"/>
                                <div class="text-tip-1">{{item}}国家标准化管理委员会批准筹 建空间科学与应用等5个国家 技术标准创新基地</div>
                                <div class="text-tip-2"><span>2020-10-06</span><span><img src="~@/assets/images/menu/浏览icon.png" width="22" height="14"/>222人浏览</span></div>
                            </div>
                        </div>
                    </template>
                    <div class="mt-3">
                        <b-pagination v-model="page.currentPage" :total-rows="page.rows" align="right"></b-pagination>
                    </div>
                </div>

                <div class="row" style="padding:20px 0;" v-show="active==key[1]">
                    <template  v-for="(item,index) in 12">
                        <div class="col-lg-3 col-md-6"  :key="index">
                            <div class="list-content">
                                <img src="~@/assets/images/menu/行业培训默认封面图.png" width="285" height="160"/>
                                <div class="text-tip-1">{{item}}国家标准化管理委员会批准筹 建空间科学与应用等5个国家 技术标准创新基地</div>
                                <div class="text-tip-2"><span>2020-10-06</span><span><img src="~@/assets/images/menu/浏览icon.png" width="22" height="14"/>222人浏览</span></div>
                            </div>
                        </div>
                    </template>
                    <div class="mt-3">
                        <b-pagination v-model="page.currentPage" :total-rows="page.rows" align="right"></b-pagination>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "menu2_3",
        data() {
            return {
                active:"碳标签培训",
                page:{
                    rows:0,
                    currentPage:1
                },
                key:["碳标签培训","商厨设计专家授课"]
            }
        },
        components: {},
        watch: {},
        mounted() {
            console.log("this.$route.params",this.$route.query)
        },
        created() {

        },
        methods: {
            activeChange(value){
                this.active=value
            }
        }
    }
</script>

<style scoped>

    .container{
        width: 1200px;
        min-width: 375px;
    }
    .active-nav{
        height: 70px;
        background-color: rgba(2, 171, 57, 1);
        color: #ffffff;
    }
    .active-nav-1{
        height: 70px;
        line-height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .list-content{
        width: 285px;
        background-color: #ffffff;
        padding-bottom:10px;
        margin-bottom: 15px;
    }
    .text-tip-1{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        line-height: 30px;
        padding: 10px 10px 5px 10px;
        height: 100px;
        line-height: 30px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /* 定义文本的行数 */
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .text-tip-2{
        padding: 5px 10px;
        display: flex;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 200;
        font-size: 16px;
        color: #888888;
        line-height: 30px;
    }
    .text-tip-2 span{
        flex:1;
    }
    .text-tip-2 span:nth-child(2){
        text-align: right;
    }
</style>
